export const MapMode = {
    Year: 'year',
    Species: 'species',
    Location: 'location'
}

export const YearMapViewMode = {
    Explorer: 'explorer',
    Species: 'species',
    Tour: 'tour'
} as const;

export const DEFAULT_MAP_CENTER: [number, number] = [-98.5795, 39.8283];
export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoib2hpb2RhdmUiLCJhIjoiY2swMDZqdWw1MjVxeDNqcW9uaG8xcW9nbyJ9.Hlqy7TBoh8QIPWC5j7AQNQ';

export const ANIMATION_DELAY = 4500;
export const SHORT_DELAY = 2500;
export const EXTRA_SHORT_DELAY = 500;
export const STARTING_ZOOM = 11;
export const SMALL_SCREEN_ZOOM_REDUCTION = 2;
export const SMALL_SCREEN_CENTER_OFFSET: [number, number] = [0, 70];
export const SMALL_SCREEN_QUERY = '(max-width: 767.98px)';
export const MAP_MAX_ZOOM = 12;
export const ZOOM_INCREMENT = 0;
export const SAME_LOCATION_SPEED = 2.2;
export const NEW_LOCATION_SPEED = 1.8;
export const ZOOMED_OUT_THRESHOLD = 7;
export const MARKER_SOURCE_ID = 'birdmap-observations';
export const MARKER_LAYER_ID = 'birdmap-observation-points';
export const ACTIVE_MARKER_LAYER_ID = 'birdmap-active-observation-point';
